import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ChevronLeft } from "lucide-react";

export default function Article() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  useEffect(() => { api.get(`/articles/${slug}`).then((r) => setA(r.data)).catch(() => setA(null)); }, [slug]);
  if (!a) return <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 py-16 font-mono text-xs uppercase tracking-[0.2em] text-[var(--ink-muted)]">Loading…</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/library" className="inline-flex items-center gap-1 text-xs font-mono uppercase tracking-wider text-[var(--ink-muted)] hover:text-[var(--ink)] mb-6"><ChevronLeft className="h-3.5 w-3.5" /> Library</Link>
      <div className="font-mono text-[11px] tracking-[0.18em] uppercase text-[var(--ink-muted)]">{a.category}</div>
      <h1 className="h-display text-4xl md:text-5xl mt-3 leading-[1.04]">{a.title}</h1>
      <p className="mt-5 text-lg text-[var(--ink-soft)] leading-relaxed">{a.summary}</p>
      <div className="mt-10 text-[15.5px] leading-[1.75] text-[var(--ink)] whitespace-pre-line">{a.body}</div>
    </div>
  );
}
